import React, { useState, useContext, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import csv from 'csvtojson'
import XLSX from 'xlsx'
import moment from 'moment'
import _ from 'lodash'
import { getSalesYear } from '../../services/apiHelper'
import Table from '../../dpe-usco/components/Table/Table'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import { Button, Modal } from 'syngenta-react-components'
import ScaleTicketDetailModal from '../ContractDashboard/ScaleTicketDetailModal'
import { getISODateFromExcel } from '../../services/utils'
import { initCompanyTrainingStructure, headerCell } from './initStruct'
import { TRAINING_ACCEPTABLE_HEADERS, TRAINING_REQUIRED_HEADERS } from './AcceptableHeaders'
import { AuthContext } from '../../services/context'
import AccessDeniedView from '../Interstitial/AccessDeniedView'
import error from '../../assets/icons/error.svg'
import error_outline from '../../assets/icons/error_outline.svg'
import close from '../../assets/icons/close.svg'


const WarningModal = ({ showWarningModal, setShowWarningModal, numberOfIssues, arrOfMissingRequiredVal, arrOfDupVals, arrOfTicketWithInvalidDates }) => {

  const createList = arr => {
    return arr.map((obj, index) => {
      return (
        <span key={`${index}`}>{`${obj} `}</span>
      )
    })
  }

  const createMissingValuesList = arr => {
    return (
      <div>
        {arr.map(missingValue => {
          return (
            <div className='df'>
              <span className='mr24'>
                {missingValue.index}
              </span>
              <div>
                {missingValue.whatIsMissing.map((val, index) => { return <span className='ml8'>{`${val}${index + 1 === missingValue.whatIsMissing.length ? '' : ','}`}</span> })}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <Modal
      autoHeight
      show={showWarningModal}
      handleClose={() => setShowWarningModal(false)}
    >
      <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
        <div className='bb1-s-lightgray df jcsb'>
          <div className='df ml15 mt15 mb15'>
            <img src={error_outline}
              alt='error icon'>
            </img>
            <div className='ml10'>
              {`Review Upload Issue${numberOfIssues > 1 ? 's' : ''}`}
            </div>
          </div>
          <img className='mr15 curp' onClick={() => setShowWarningModal(false)} src={close}
            alt='close icon'>
          </img>
        </div>
        <div className='p15'>
          <div>
            <span className='fw600'>{numberOfIssues}</span>
            <span>
              {`issue${numberOfIssues > 1 ? 's' : ''} found. Edit and reupload the corrected source file in order to save. See below for list of identified row${numberOfIssues > 1 ? 's' : ''}.`}
            </span>
            {arrOfMissingRequiredVal?.length ?
              <>
                <div className='fw600 mt25 mb10'>{`MISSING REQUIRED DATA FIELD${arrOfMissingRequiredVal.length > 1 ? 'S' : ''}`}</div>
                {createMissingValuesList(arrOfMissingRequiredVal)}
              </> : null
            }
            {arrOfDupVals?.length ?
              <>
                <div className='fw600 mt25 mb10'>{`DUPLICATE${arrOfDupVals.length > 1 ? 'S' : ''} WITHIN SOURCE FILE`}</div>
                <div>
                  {createList(arrOfDupVals)}
                </div>
              </> : null
            }
            {arrOfTicketWithInvalidDates?.length ?
              <>
                <div className='fw600 mt25 mb10'>{`TICKET${arrOfTicketWithInvalidDates.length > 1 ? 'S' : ''} WITH INVALID DATE FOUND`}</div>
                <div>
                  {createList(arrOfTicketWithInvalidDates)}
                </div>
              </> : null
            }
          </div>
        </div>
      </div>
    </Modal>
  )
}

const CompanyUploader = ({ setHasUpload, checkGrowerModalVisibility, toggleCheckGrowerModalVisibility, setHasAllRequiredData, setPageRefresh, setLoading, setShowSucessModal, setParentTableData, setCurrentParentProductionYear }) => {
  const [tableData, setTableData] = useState()
  const [showWarningModal, setShowWarningModal] = useState(false)
  const [showWarningPrompt, setWarningPrompt] = useState(false)
  const [numberOfIssues, setNumberOfIssues] = useState(0)
  const [arrOfMissingRequiredVal, setArrOfMissingRequiredVal] = useState([])
  const [arrOfTicketWithInvalidDates, setArrOfTicketWithInvalidDates] = useState([])
  const [arrOfDupVals, setArrOfDupVals] = useState([])
  const [hasPermission, setHasPermission] = useState(true)
  const [structure, setStructure] = useState({
    headers: [],
    dataKeys: []
  })
  const { hasAccess } = useContext(AuthContext)
  const [currentProductionYear, setCurrentProductionYear] = useState('')

  useEffect(() => {
    setHasPermission(hasAccess('ANY', 'company-training'))
  }, [hasAccess])

  
  useEffect(() => {
    if (!currentProductionYear)
      getSalesYear()
        .then(res => {
          setCurrentProductionYear(res.data.sales_year)
          setCurrentParentProductionYear(res.data.sales_year)
        })
  })

  const updateJSONKeys = json => {
    return json.map((obj, index) => {
      for (var oldKey in obj) {
        let newKey = parseHeaders(oldKey)
        if (oldKey !== newKey) {
          Object.defineProperty(obj, newKey,
            Object.getOwnPropertyDescriptor(obj, oldKey))
          delete obj[oldKey]
        }
      }

      const convertToString = obj => {
        const newObj = {}
        Object.entries(obj).forEach(([key, val]) => {
          if (key === 'Date') {
            return newObj[key] = typeof obj.Date === 'string' ? moment(obj.Date).format('MM/DD/YY') : moment(getISODateFromExcel(obj.Date)).format('MM/DD/YY')
          }
          return newObj[key] = val.toString()
        })
        return newObj
      }

      return Object.assign({ 'Index': index + 1 }, convertToString(obj))
    })
  }

  const checkForErrors = json => {
    const setErrorIcon = obj => {
      if (typeof obj.Index === 'number') {
        obj.Index = (<div className='df jcsb'>{obj.Index} {<img className='mr15' alt='error icon' src={error_outline} />}</div>)
      }
    }
    let ticketWithInvalidDates = []
    let ticketWithMissingValues = []
    let arrToTestDups = []
    let dupIndexMap = {}
    let arrOfDupIndex = []
    json.forEach((obj, index) => {
      const whatIsMissing = []
      for (let i = 0; i < TRAINING_REQUIRED_HEADERS.length; i++) {
        const currentHeader = TRAINING_REQUIRED_HEADERS[i]
        if (!(currentHeader in obj) || !obj[currentHeader]) {
          obj.customRowClass = 'bgc-red-100'
          whatIsMissing.push(TRAINING_REQUIRED_HEADERS[i])
          setErrorIcon(obj)
        }
      }
      if (whatIsMissing.length) {
        ticketWithMissingValues.push({ index: index + 1, whatIsMissing })
        setErrorIcon(obj)
      }

      return obj
    })

    if (arrToTestDups.length) {
      const findDuplicates = arr => arr.filter((item, i) => arr.includes(item, i + 1))
      const stringfyArr = arrToTestDups.map(obj => JSON.stringify(obj))
      let parsedResults = findDuplicates(stringfyArr).map(obj => JSON.parse(obj))
      arrOfDupIndex = parsedResults.map(obj => {
        let returnVal = []
        for (const [key] of Object.entries(dupIndexMap)) {
          if (dupIndexMap[key] === obj.ticketNumber) {
            returnVal.push(key)
          }
        }
        return returnVal
      })
    }
    if (arrOfDupIndex.length) {
      arrOfDupIndex = _.flatten(arrOfDupIndex)
    }
    arrOfDupIndex.forEach(dupeIndex => {
      json.forEach(scaleTickObj => {
        if (scaleTickObj.Index.toString() === dupeIndex) {
          scaleTickObj.customRowClass = 'bgc-red-100'
          scaleTickObj.Index = (<div className='df jcsb'>{scaleTickObj.Index} {<img className='mr15' alt='error icon' src={error_outline} />}</div>)
        }
      })
    })
    return {
      ticketWithMissingValues,
      arrOfDupIndex,
      ticketWithInvalidDates
    }
  }

  const renderJSON = JSONobj => {
    let headerArr = [
      {
        value: 'Index',
        format() {
          return (<div key='space' className='cell df aic' />)
        }
      }
    ]
    let dataArr = ['Index']
    for (var property in JSONobj[0]) {
      let parsedHeader = parseHeaders(property)
      headerArr.push({
        value: parsedHeader,
        format() {
          return headerCell(this.value)
        }
      })
      dataArr.push(parsedHeader)
    }
    JSONobj = updateJSONKeys(JSONobj)
    let errorObj = checkForErrors(JSONobj)
    if (errorObj?.ticketWithMissingValues?.length || errorObj?.arrOfDupIndex?.length || errorObj?.ticketWithInvalidProductionYear?.length || errorObj?.ticketWithInvalidDates?.length) {
      setArrOfMissingRequiredVal(errorObj.ticketWithMissingValues)
      setArrOfDupVals(errorObj.arrOfDupIndex)
      setArrOfTicketWithInvalidDates(errorObj.ticketWithInvalidDates)
      setNumberOfIssues((errorObj.ticketWithMissingValues.length || 0) + (errorObj.arrOfDupIndex.length) + (errorObj?.ticketWithInvalidDates?.length))
      setWarningPrompt(true)
    } else {
      setHasAllRequiredData(true)
    }

    setTableData(JSONobj)
    setParentTableData(JSONobj)
    const setUpStruc = {
      headers: headerArr,
      dataKeys: dataArr,
      rowFormat: {
        'Ticket Number': {
          format: data => {
            return (
              <ScaleTicketDetailModal data={data} />
            )
          }
        }
      }
    }
    setStructure(setUpStruc)
  }


  const onDrop = acceptedFiles => {
    const reader = new FileReader()
    acceptedFiles.forEach(file => {
      reader.onload = () => {
        const fileAsBinaryString = reader.result
        if (acceptedFiles[0] && acceptedFiles[0]?.type.endsWith('csv')) {
          csv({
            noheader: true,
            output: 'json'
          })
            .fromString(fileAsBinaryString)
            .then(csvRows => {
              const toJSON = []
              csvRows.forEach((aCsvRow, i) => {
                if (i !== 0) {
                  const builtObject = {}
                  Object.keys(aCsvRow).forEach(aKey => {
                    const valueToAddInBuiltObject = aCsvRow[aKey]
                    const keyToAddInBuiltObject = csvRows[0][aKey]
                    builtObject[keyToAddInBuiltObject] = valueToAddInBuiltObject
                  })
                  toJSON.push(builtObject)
                }
              })
              renderJSON(toJSON)
            })
        } else if (acceptedFiles[0]?.type.endsWith('sheet') || acceptedFiles[0]?.path.endsWith('xls')){
          let workBook = XLSX.read(fileAsBinaryString, { type: 'binary' })
          let jsonData = workBook.SheetNames.reduce((init, name) => {
            const sheet = workBook.Sheets[name]
            return XLSX.utils.sheet_to_json(sheet)
          }, {})
          renderJSON(jsonData)
        }
        setHasUpload(true)
      }
      reader.readAsBinaryString(file)
    })
  }

  const parseHeaders = header => {
    let returnHeader
    const normalizeHeader = header.toLowerCase().trim().split('.').join('')
    for (const [headerName, headerArray] of Object.entries(TRAINING_ACCEPTABLE_HEADERS)) {
      if (headerArray.includes(normalizeHeader)) {
        returnHeader = headerName
      }
    }
    return returnHeader ? returnHeader : header
  }

  const clear = () => {
    setTableData()
    setParentTableData()
    setStructure({
      headers: [],
      dataKeys: []
    })
    setArrOfDupVals([])
    setHasAllRequiredData(false)
    setArrOfMissingRequiredVal([])
    setHasUpload(false)
    setWarningPrompt(false)
    setNumberOfIssues(0)
  }

  const { open, getRootProps, getInputProps } = useDropzone({ onDrop, noClick: true, noKeyboard: true, accept: '.csv, .xls, .xlsx' })

  const prompt = (
    <div {...getRootProps()}>
      {<p>Drag-and-drop or choose a file to import Stewardship Training <br /> Supported file types: .csv, .xls, or .xlsx</p>}
      <input {...getInputProps()} />
      <Button text='Choose File' onClick={open} />
    </div>)

  const ButtonRow = () => {
    return (
      <div className='df mt25'>
        <div className='fxdrc aifs'>
          {tableData
            ?
            <>
              <Button text='Clear File' onClick={clear} />
            </>
            :
            <>
              <div className='mb5 fz15'>Upload CSV or XLS</div>
              <Button text='Choose File' onClick={open} />
            </>}
        </div>
        {
          showWarningPrompt ?
            <div className='mauto bd1-s-red bgc-red-100 mb20'>
              <div className='df pt15 pr10 pl10 pb15'>
                <img
                  alt='error icon'
                  src={error} />
                <div className='pr5 pl5 mt5'>
                  {`${numberOfIssues} issue${numberOfIssues > 1 ? 's' : ''} found. Edit and reupload the corrected source file in order to save.`}
                </div>
                <Button customClassName='m0' text={'Review Issue'} clickHandler={() => setShowWarningModal(true)}></Button>
              </div>
            </div> : null

        }
      </div>
    )
  }

  const ScaleTicketsHeader = () => {
    return (
      <div className='df fxdrr jcsb mb24'>
        <div className='df aic'>
          <span className='fw600'>Stewardship Training</span>
          {tableData ? <span className='ml4 fw600 c-darkgray'>({tableData.length})</span> : null}
        </div>
        <div className='df fxdrr aic'>
          <span>Contract Year:</span>
          <div className='df aic jcc w60 h40 bgc-lightgray p10 bdrs-4 ml8'>
            {currentProductionYear ? <span>{currentProductionYear}</span> : <div className='loader h20 w20' />}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {
        hasPermission ?
          <div>
            <ButtonRow />
            <WarningModal arrOfTicketWithInvalidDates={arrOfTicketWithInvalidDates} arrOfDupVals={arrOfDupVals} showWarningModal={showWarningModal} setShowWarningModal={setShowWarningModal} numberOfIssues={numberOfIssues} arrOfMissingRequiredVal={arrOfMissingRequiredVal} />
            <ScaleTicketsHeader />
            {tableData
              ? <Table data={tableData} structure={structure} />
              : <Table statusComponentHeight='h400' structure={initCompanyTrainingStructure} statusComponent={<TableStatus status={'EMPTY'} prompt={prompt} />} />}
          </div> :
          <>
            <AccessDeniedView />
          </>
      }
    </>
  )
}

export default CompanyUploader